<script setup>
import { defineProps, defineEmits, inject } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
const store = useStore()
const storeFourBaseUrl = inject('storeFourBaseUrl')
const props = defineProps({
  items: {
    type: Array,
    required: true
  }
})
const router = useRouter()

const emit = defineEmits(['openNextMenuLevel'])

const getIconSrc = (image) => {
  return `${storeFourBaseUrl}/filepond/menu/${image}`
}
const closeMenu = () => {
  store.dispatch('megaMenu/closeMenu')
}
const nextLevelOpener = (parentId, level, name, link) => {
  if (!link){
    emit("openNextMenuLevel", { parent_id: parentId, level_item: level, level_name: name })
  } else {
    //If link is external redirect to it
    if (link.startsWith('http')) {
      window.location = link
    } else { // else go to filtered courses with vue router
      router.push(link)
    }
    store.dispatch('megaMenu/closeMenu')
  }
}
</script>

<template>
  <div>
    <v-list-item v-if="$vuetify.display.mdAndDown" @click="closeMenu" width="100%" class="d-flex justify-center">
      <v-icon size="large" icon="$mdiMinus"></v-icon>
    </v-list-item>
    <v-list-item
      :class="[i>0 && $vuetify.display.mdAndDown?'border-t-sm':'',i>=props.items.length-1 && $vuetify.display.mdAndDown?'mb-13':'']"
      v-for="(item, i) in props.items"
      :key="i"
    >
      <v-list-item-title class="text-grey-darken-2" v-if="!$vuetify.display.mdAndDown">
        {{ item.title }}
      </v-list-item-title>
      <v-list-item
        :class="[$vuetify.display.mdAndDown?'my-2 ':'']"
        color="primary"
        class="rounded-xl mega-menu__list"
        v-for="(child, i) in item.children"
        :key="i"
        :value="child"
        @click="nextLevelOpener(child.id, 1, child.title, child.link)"
      >
        <template v-slot:prepend>
          <v-img :src="getIconSrc(child.icon_img)" width="30" class="ml-2" />
        </template>
        <template v-slot:append>
          <v-icon style="width: 15px" :icon="$vuetify.display.mdAndDown?'$mdiArrowLeft':'$chevronLeft'"></v-icon>
        </template>
        <v-list-item-title class="font-weight-bolder">
          {{ child.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list-item>
    <v-list-item v-if="$vuetify.display.mdAndDown" width="100%" class="position-fixed fixed-button bg-white py-3">
      <v-btn class="border-secondary" @click="closeMenu()" :to="{name:'courses'}" width="100%" height="45px" variant="outlined" style="letter-spacing: 0"> مشاهده همه دوره‌ها
      </v-btn>
    </v-list-item>
  </div>
</template>


<style lang="scss">
.fixed-button {
  bottom: -10px;
}
.mega-menu__list{
  .v-list-item__append{
    width: 15px;
  }
}

</style>
